import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/AddAccountModal/AddAccountModalContent";

const I18n = I18nUtil.createScoped(Translations);

/**
 * Portfolio 连接入口（Ed-first 特例：portfolio_link 是唯一不进 LLM 的 referenceType，
 * 后端 chat-ai-processor 直接 emit request_portfolio 交互卡片）。
 * 方括号记录用户点击的操作，空正文不作为用户输入进入模型。
 */
export const buildPortfolioUploadHoldingsChatQuestion = (): string =>
  `[${I18n.t("Send Ed a screenshot")}](referenceType=portfolio_link)\n`;
